import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

function BackButton() {
  const history = useHistory();

  const handleClick = useCallback(() => {
    history.goBack();
  }, []);
  
  return (
    <>
      <button 
        type="button"
        className="btn_exit4 hide_pc hide_t"
        onClick={handleClick}
      >
        <img src={`${process.env.PUBLIC_URL}/static/images/icon/ic-ar-left-white.svg`} alt="" />
      </button>
      <button 
        type="button"
        className="btn_exit hide_pc hide_m"
        onClick={handleClick}
      >
        <img src={`${process.env.PUBLIC_URL}/static/images/icon/ic_back@2x.png`} alt="" />
      </button>
    </>
  );
}

export default BackButton;